const mediaQuery = window.matchMedia('(min-width: 769px)');
let isProcessed = false;
domManipulation(mediaQuery);

mediaQuery.addEventListener('change', (e) => {
    if (!isProcessed) {
        domManipulation(e);
    }
});

//DOMを操作する関数
function domManipulation(e) {
    if (e.matches) {
        const ap_stockist = document.getElementById('ap_stockist');
        const ap_stockist_children = Array.from(ap_stockist.children);
        const ap_stockist_wrapper = document.createElement('div');
        ap_stockist_wrapper.className = 'ap_stockist_wrapper';
        const ap_stockist_stores_wrapper = document.createElement('div');
        ap_stockist_stores_wrapper.className = 'ap_stockist_stores_wrapper';
        const ap_stockist_areas_wrapper = document.createElement('div');
        ap_stockist_areas_wrapper.className = 'ap_stockist_areas_wrapper';
        ap_stockist_wrapper.appendChild(ap_stockist_areas_wrapper);
        ap_stockist_wrapper.appendChild(ap_stockist_stores_wrapper);
        ap_stockist.appendChild(ap_stockist_wrapper);

        const ap_stockist_children_items = ap_stockist_children.slice(1);
        if (ap_stockist_children_items.length > 0) {
            ap_stockist_children_items.forEach(item => {
                ap_stockist_stores_wrapper.appendChild(item);
            });
        }

        const areaNameElements = document.querySelectorAll('.ap_stockist_content_area_name_pc');
        if (areaNameElements.length > 0) {
            areaNameElements[0].classList.add('active');
        }
        areaClickScrool(areaNameElements, ap_stockist_areas_wrapper);
        areaActiveCheck(areaNameElements);
        
        // ScrollTriggerでピン留め（カクつき修正版）
        areaTranslation(ap_stockist_stores_wrapper, ap_stockist_areas_wrapper);
        
        ap_stockist.classList.add('loaded');

        e.addEventListener('change', (e) => {
            if (e.matches) {
                ScrollTrigger.refresh();
            }
        });
        isProcessed = true;
    }
}

function areaClickScrool(areaNameElements, ap_stockist_areas_wrapper) {
    // Safariかどうかを判定
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    areaNameElements.forEach(element => {
        ap_stockist_areas_wrapper.appendChild(element);
        element.addEventListener('click', function () {
            const targetId = this.getAttribute('data-target');
            if (targetId) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 115;
                    
                    if (isSafari) {
                        // Safariの場合はポリフィルを使用
                        smoothScrollTo(targetPosition, 500);
                    } else {
                        // Chrome等は標準のスムーススクロール
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        });
    });
}

// Safari用のスムーズスクロール
function smoothScrollTo(targetPosition, duration) {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}

// 現在いるエリアをチェックする関数
function areaActiveCheck(areaNameElements) {
    let activeCheckTicking = false;
    window.addEventListener('scroll', function () {
        if (!activeCheckTicking) {
            window.requestAnimationFrame(function () {
                // 各エリアの要素を取得してチェック
                areaNameElements.forEach(element => {
                    const targetId = element.getAttribute('data-target');

                    if (targetId) {
                        const targetElement = document.getElementById(targetId);

                        if (targetElement) {
                            const rect = targetElement.getBoundingClientRect();
                            // 要素が画面上部付近（120px + α）にあるかチェック
                            if (rect.top <= 200 && rect.bottom > 120) {
                                // 全てのactiveクラスを削除
                                areaNameElements.forEach(el => el.classList.remove('active'));
                                // 現在の要素にactiveを追加
                                element.classList.add('active');
                            }
                        }
                    }
                });

                activeCheckTicking = false;
            });

            activeCheckTicking = true;
        }
    });
}

// エリアを固定する関数
function areaTranslation(ap_stockist_stores_wrapper, ap_stockist_areas_wrapper) {
    if (!ap_stockist_stores_wrapper || !ap_stockist_areas_wrapper) return;

    ScrollTrigger.create({
        trigger: ap_stockist_stores_wrapper,
        start: "top 120px", 
        end: () => "+=" + (ap_stockist_stores_wrapper.offsetHeight - ap_stockist_areas_wrapper.offsetHeight - 20),
        pin: ap_stockist_areas_wrapper,
        pinSpacing: false,
        anticipatePin: 1,
    });
}